import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaHeart,
} from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-4">

          {/* Company Info */}
          <div className="col-12 col-md-4">
            <div className="footer-brand">
              <div className="logo-box">
                <img src="/mtlogo.jpg" alt="MT Logo" />
              </div>
              <div>
                <h5>Mahendra Traders</h5>
                <small>Trusted Local Supplier</small>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="col-12 col-md-4">
            <div className="footer-item">
              <FaMapMarkerAlt />
              <p>
                Shop no -58, Naliya Bakhal Maa House,<br />
                Bharat Marg, Behind Kanch Mandir,<br />
                Indore, MP - 452002
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="col-12 col-md-4">
            <div className="footer-item">
              <FaPhone />
              <a href="tel:09827248061">098272 48061</a>
            </div>
          </div>

        </div>

        <hr />

        <div className="footer-bottom text-center">
          <p>
            © {new Date().getFullYear()}{" "}
            <span>Tech Virtue Solutions</span> · Made with{" "}
            <FaHeart className="heart" /> in Indore
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;